function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglepay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 12,
  fill: "none",
  viewBox: "0 0 33 12"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#googlepay_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M10.859 5.104q0-.511-.091-1.015H5.784V6.01h2.854c-.059.307-.182.6-.364.86a2.4 2.4 0 0 1-.691.655v1.25h1.703c.998-.867 1.573-2.152 1.573-3.671",
  style: {
    fill: "#4285f4",
    fill: "color(display-p3 .2588 .5216 .9569)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M5.784 9.981c1.425 0 2.627-.443 3.502-1.205L7.583 7.528c-.475.305-1.085.477-1.799.477-1.378 0-2.548-.877-2.966-2.06H1.063v1.287a5.1 5.1 0 0 0 1.948 2.007 5.5 5.5 0 0 0 2.773.742",
  style: {
    fill: "#34a853",
    fill: "color(display-p3 .2039 .6588 .3255)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M2.818 5.946a2.83 2.83 0 0 1 0-1.91V2.749H1.063A4.76 4.76 0 0 0 .5 4.991c0 .779.193 1.547.563 2.242z",
  style: {
    fill: "#fbbc04",
    fill: "color(display-p3 .9843 .7373 .0157)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6368",
  d: "M15.635 5.863V9.38h-1.182V.693h3.133a3 3 0 0 1 1.094.184c.348.13.666.322.935.568.267.235.48.52.626.836a2.4 2.4 0 0 1 0 2.005 2.5 2.5 0 0 1-.626.836q-.822.74-2.03.74h-1.951zm0-4.1v3.033h1.981c.314.006.624-.076.889-.236a1.54 1.54 0 0 0 .603-.66c.128-.271.168-.572.116-.865a1.5 1.5 0 0 0-.408-.782q-.015-.015-.033-.03c-.149-.15-.33-.27-.532-.349a1.6 1.6 0 0 0-.636-.112zm7.552 1.48q1.311 0 2.067.66.756.662.758 1.814V9.38H24.88v-.824h-.05q-.735 1.02-1.954 1.019-1.04 0-1.74-.582a1.9 1.9 0 0 1-.524-.654 1.8 1.8 0 0 1-.176-.802q0-.922.74-1.467.737-.545 1.97-.546 1.052 0 1.733.364v-.256a1.2 1.2 0 0 0-.126-.545 1.3 1.3 0 0 0-.362-.442 1.73 1.73 0 0 0-1.14-.406q-.99 0-1.568.788l-1.038-.62q.855-1.164 2.54-1.164m-1.53 4.318c0 .142.035.282.103.408a.9.9 0 0 0 .289.319 1.5 1.5 0 0 0 .918.291 1.95 1.95 0 0 0 1.329-.52q.587-.523.587-1.226-.554-.416-1.542-.416-.72 0-1.2.327-.485.333-.485.817zM32.5 3.438 28.555 12h-1.22L28.8 9.004l-2.595-5.566h1.284l1.874 4.27h.025l1.825-4.27z",
  style: {
    fill: "#5f6368",
    fill: "color(display-p3 .3725 .3882 .4078)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M5.784 1.976a2.96 2.96 0 0 1 2.027.748L9.32 1.3A5.25 5.25 0 0 0 5.784 0c-.98 0-1.94.258-2.773.743A5.1 5.1 0 0 0 1.063 2.75l1.755 1.287c.418-1.183 1.588-2.06 2.966-2.06",
  style: {
    fill: "#ea4335",
    fill: "color(display-p3 .9176 .2627 .2078)",
    fillOpacity: 1
  }
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "googlepay_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v12H0z",
  style: {
    fill: "#fff",
    fillOpacity: 1
  },
  transform: "translate(.5)"
}))));
export { SvgGooglepay as ReactComponent };